import React, { useContext, useEffect, useState } from 'react';
import { AgendaContext } from '../../contexts/AgendaContext';

function VersionBar() {
  const { getHealthCheck, getLocalHostname } = useContext(AgendaContext);
  const [healthCheckData, setHealthCheckData] = useState(null);
  const [localHostname, setLocalHostname] = useState(null);

  useEffect(() => {
    const fetchHealthCheck = async () => {
      try {
        const data = await getHealthCheck();  
        setHealthCheckData(data);
      } catch (error) {
        console.error('Error fetching health check:', error);
      }
    };

    const fetchLocalHostname = async () => {
      try {
        const data = await getLocalHostname();
        setLocalHostname(data);
      } catch (error) {
        console.error('Error fetching local hostname:', error);
      }
    };

    fetchHealthCheck();
    fetchLocalHostname();
  }, []);

  const parseHostname = (hostname) => {
    if (!hostname) return 'Local';
    let result = hostname.replace('prestador-interoperabilidad-frontend-', '');
    result = result.replace('prestador-interoperabilidad-backend-', '');
    return result;
  };

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        background: 'transparent',
        padding: '3.6px',
        zIndex: 1000
      }}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column'
        }}>
        <p
          style={{
            margin: '0',
            marginLeft: '3px',
            textAlign: 'left',
            fontSize: '0.5rem',
            color: 'rgba(0,0,0,0.5)'
          }}>
          api v{healthCheckData?.data?.appVersion || 'N/A'}
        </p>
        <p
          style={{
            margin: '0',
            marginLeft: '3px',
            textAlign: 'left',
            fontSize: '0.5rem',
            color: 'rgba(0,0,0,0.4)'
          }}>
          {parseHostname(healthCheckData?.data?.hostname)}
        </p>
      </div>

      <div
        style={{
          display: 'flex',
          flexDirection: 'column'
        }}>
        <p
          style={{
            margin: '0',
            marginRight: '3px',
            textAlign: 'right',
            fontSize: '0.5rem',
            color: 'rgba(0,0,0,0.5)'
          }}>
          v{process.env.REACT_APP_VERSION}
        </p>
        <p
          style={{
            margin: '0',
            marginRight: '3px',
            textAlign: 'right',
            fontSize: '0.5rem',
            color: 'rgba(0,0,0,0.4)'
          }}>
          {parseHostname(localHostname?.hostname)}
        </p>
      </div>
    </div>
  );
}

export default VersionBar;